export default "__VITE_ASSET__$SgV_1Vm__"